import React from 'react';
import { Table as MuiTable, TableContainer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles({
  root: {
    borderRadius: 0,
    border: 'none'
  }
});
export function Table(_ref) {
  var ariaLabel = _ref['aria-label'],
    children = _ref.children,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'table' : _ref$component,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 'normal' : _ref$padding,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$stickyHeader = _ref.stickyHeader,
    stickyHeader = _ref$stickyHeader === void 0 ? true : _ref$stickyHeader;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(TableContainer, {
    classes: classes
  }, /*#__PURE__*/React.createElement(MuiTable, {
    "aria-label": ariaLabel,
    component: component,
    padding: padding,
    size: size,
    stickyHeader: stickyHeader
  }, children));
}